var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 866"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 252",
    cx: 5,
    cy: 12,
    r: 2,
    fill: "black",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 253",
    cx: 11,
    cy: 12,
    r: 2,
    fill: "black",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 350",
    d: "M21.1295 9H15.8705C15.4846 9 15.2442 9.41861 15.4386 9.75194L18.0681 14.2596C18.261 14.5904 18.739 14.5904 18.9319 14.2596L21.5614 9.75194C21.7558 9.41861 21.5154 9 21.1295 9Z",
    fill: "black",
    fillOpacity: 0.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.6343142b2ad9d6b2ce7965cb5ea7b684.svg";
export { ForwardRef as ReactComponent };